// extracted by mini-css-extract-plugin
export default {"container":"PZjU","item":"IODT"};